
export const LOGIN_REQUEST = 'LOGIN_REQUEST';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const LOGIN_ERROR = 'LOGIN_ERROR';